<template>
  <section v-if="products.length" class="mt-12">
    <SectionHeading
      :eyebrow="eyebrow"
      :title="title"
      :subtitle="subtitle"
      compact
    />
    <ProductGrid :products="products" />
  </section>
</template>

<script setup lang="ts">
import type { Product } from '~/types'

const props = withDefaults(defineProps<{
  excludeProductId?: number
  eyebrow?: string
  title?: string
  subtitle?: string
}>(), {
  eyebrow: 'Continuă de unde ai rămas',
  title: 'Vizualizate recent',
  subtitle: 'Produse pe care le-ai consultat recent.',
})

const { fetchProducts } = useRecentlyViewed()
const products = ref<Product[]>([])

onMounted(async () => {
  products.value = await fetchProducts(props.excludeProductId)
})
</script>
